import React from 'react'
import EcommerceDashboard from './Management'
import { ToastContainer } from 'react-toastify'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from './AuthContext';
import Login from './pages/Login';
import ProtectedRoute from './ProtectedRoute';

export default function App() {
  return (
   <AuthProvider>
  
   <Router>
        <Routes>
          
        <Route path="/login" element={<Login />} />
           <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <EcommerceDashboard />
              </ProtectedRoute>
            }
          >
            {/* Nested route - this will render in the Outlet of DashboardLayout */}
            <Route index element={<EcommerceDashboard />} />
            {/* Add more nested routes here as needed */}
            {/* <Route path="folder" element={<Folder />} /> */}
            {/* <Route path="exam" element={<Exam />} /> */}
            {/* <Route path="videos" element={<Videos />} /> */}
          </Route>
        </Routes>
    {/* <EcommerceDashboard/> */}

      <ToastContainer />
      </Router>
    </AuthProvider>
  )
}
